import React from "react";
import loader from '../images/loader.gif';


//loader component
const Loader = ()  => {

    return(
        <>
         return (
                <div className="preloader">
                <div className="preloader-inner">
                    <img src={loader} alt="Preloader" />
                </div>
                </div>
            );
            
        </>
    );
}

export default Loader;